export default __webpack_public_path__ + "static/media/crystalball.ee248a8e.svg";